import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import User from "../icons/user.jsx";
import "../style/header.css";
import InstallPWA from "./InstallPWA.jsx";
import { removeUser } from "../utils/authUtils.js";
import { AuthContext } from "../context/AuthContext";
import { useTranslation } from "react-i18next";
import { globalT } from "../utils/globalUtils.js";
import i18next from "i18next";
import { useLocation } from "react-router-dom";

const Header = () => {
  const { userLog, setUserLog } = useContext(AuthContext);
  const { i18n } = useTranslation();
  const currentLanguage = i18next.language;
  const location = useLocation();
  const navigate = useNavigate();

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "es" : "en";
    i18n.changeLanguage(newLang);
    localStorage.setItem("i18nextLng", newLang);
  };

  const isLocalhost = window.location.hostname === "localhost";

  return (
    <div className="m-header">
      <div className="mdl-container">
        <div
          className={`language-toggle ${
            location.pathname === "/login" ? "hide" : ""
          }`}
        >
          <button
            className="language-toggle-button"
            onClick={() => toggleLanguage()}
            type="button"
          >
            {currentLanguage === "en" ? "English" : globalT("Español")}
          </button>
        </div>

        {isLocalhost ? null : <InstallPWA />}
        <Link to="/" className="m-title-header">
          RE-Write
        </Link>
        <div className={`profile-icon ${userLog ? "show" : "hide"}`}>
          <User />
          <div className="dropdown">
            <Link className="profile" to="/profile">
              {globalT("Mi perfil")}
            </Link>
            <div
              className="logout"
              onClick={() => {
                // Auth stateless (el token es el _id); no hay sesión de servidor
                // que invalidar, así que basta con limpiar la sesión local y
                // redirigir a login (mismo patrón que el borrado de cuenta en
                // ProfilePage). El navigate garantiza la redirección aunque el
                // guard reactivo no esté montado (p. ej. en local/dev).
                removeUser();
                setUserLog(false);
                navigate("/login");
              }}
            >
              {globalT("Cerrar sesión")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
